var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"png","imageName":"BenefitHub","welcomeGroup":"BenefitHub members","routePath":"benefithub"}})
}
var staticRenderFns = []

export { render, staticRenderFns }